<template>
  <div class="tekmodal" :class="{ loadingState: isUploadLoading }">
    <!-- MODAL HEADER -->
    <div class="modalheader">
      <div class="headerleft">
        <div class="ico">
          <img src="../../assets/sidebar/opdrachten-ico.svg" alt="" />
        </div>
        <h4 class="header">Opdracht</h4>
        <h4
          v-if="opdracht[0].geannuleerd == true"
          class="header"
          style="color:red;"
        >
          GEANNULEERD
        </h4>
        <h4
          v-if="opdracht[0].onhold == true"
          class="header"
          style="color:orange;"
        >
          ON HOLD (inactief)
        </h4>
      </div>
      <div class="header-buttons">
        <div class="close-btn" @click="closemodal">
          <img src="../../assets/close-btn.png" alt="" class="close-x" />
        </div>
      </div>
    </div>

    <!-- SAVE CHANGES sectie -->
    <div
      class="savesection"
      v-if="isOpdrachtEdited == true"
      @click="saveChanges()"
    >
      <span>Sla deze veranderingen op</span>
    </div>

    <!-- opdracht hoofdblok sectie -->
    <div class="section blue">
      <div
        v-if="opdrachtgeverAcceptedCFVoorwaarden"
        class="notification accepted"
      >
        <div class="top">
          <div class="itemmm">
            <i class="fad fa-shield-check"></i>
          </div>
          <span>
            Akkoord met C.F. voorwaarden
          </span>
        </div>
      </div>
      <div
        v-if="!opdrachtgeverAcceptedCFVoorwaarden"
        class="notification rejected"
      >
        <div class="top">
          <div class="itemmm">
            <i class="fad fa-exclamation-triangle"></i>
          </div>
          <span v-if="!cfVoorwaardenMailGestuurd">
            Er is nog geen akkoordmail verstuurd over de C.F. voorwaarden
          </span>
          <span v-if="cfVoorwaardenMailGestuurd">
            Deze opdrachtgever is nog niet akkoord gegaan met de C.F.
            voorwaarden
          </span>
        </div>
        <button v-if="!cfVoorwaardenMailGestuurd" @click="sendCFmail">
          Verstuur Akkoordmail
        </button>
        <button v-if="cfVoorwaardenMailGestuurd" @click="sendCFmail">
          Verstuur Opnieuw
        </button>
      </div>
    </div>
    <div class="section blue">
      <input
        type="text"
        class="titeltekst tekstveld blue"
        v-model="opdracht[0].bedrijfsnaam"
        @input="isOpdrachtEdited = true"
      />
      <!-- <span class="titeltekst">{{opdracht[0].bedrijfsnaam}}</span> -->
      <div class="threecolumnsholder">
        <div>
          <input
            type="text"
            class="tekstveld blue"
            v-model="opdracht[0].voornaam"
            @input="isOpdrachtEdited = true"
            placeholder="Voornaam"
          />

          <span v-if="!opdracht[0].opdrachtnummermaand"
            >CDT.{{ opdracht[0].opdrachtnummerjaar }}.{{
              opdracht[0].opdrachtnummer
            }}</span
          >
          <span v-if="opdracht[0].opdrachtnummermaand"
            >CDT.{{ opdracht[0].opdrachtnummerjaar }}.{{
              opdracht[0].opdrachtnummermaand
            }}.{{ opdracht[0].opdrachtnummer }}</span
          >
          <input
            type="text"
            class="tekstveld blue"
            v-model="opdracht[0].telefoonnummer"
            @input="isOpdrachtEdited = true"
            placeholder="telefoonnummer"
          />
        </div>
        <div>
          <input
            type="text"
            class="tekstveld blue"
            v-model="opdracht[0].achternaam"
            @input="isOpdrachtEdited = true"
            placeholder="Voornaam"
          />
          <input
            type="text"
            class="tekstveld blue"
            v-model="opdracht[0].email"
            @input="isOpdrachtEdited = true"
            placeholder="email"
          />
        </div>
      </div>
      <div class="threecolumnsholder">
        <div>
          <!-- <input
            type="text"
            class="tekstveld blue"
            v-model="opdracht[0].tekenprogramma"
            @input="isOpdrachtEdited = true"
            placeholder="tekenprogramma"
          /> -->
          <!-- tekenprogramma -->
          <select
            v-model="opdracht[0].tekenprogramma"
            @change="isOpdrachtEdited = true"
            class="tekstveld correctSelect"
          >
            <option value="">Tekenprogramma</option>
            <option value="Geen voorkeur">Geen voorkeur</option>
            <option value="AutoCAD">AutoCAD</option>
            <option value="Autodesk Revit">Autodesk Revit</option>
            <option value="SolidWorks">SolidWorks</option>
            <option value="BricsCAD">BricsCAD</option>
            <option value="Autodesk Inventor">Autodesk Inventor</option>
            <option value="Solid Edge">Solid Edge</option>
            <option value="Vectorworks">Vectorworks</option>
            <option value="Rhinoceros">Rhinoceros</option>
            <option value="MicroStation">MicroStation</option>
          </select>
          <!-- <input
            type="text"
            class="tekstveld blue"
            v-model="opdracht[0].typeopdracht"
            @input="isOpdrachtEdited = true"
            placeholder="type odpracht"
          /> -->
          <!-- type opdracht -->
          <select
            v-model="opdracht[0].typeopdracht"
            @change="isOpdrachtEdited = true"
            class="tekstveld correctSelect"
          >
            <option value="">Type opdracht</option>
            <option value="Project">Project</option>
            <option value="Opdracht">Opdracht</option>
            <option value="Intern">Intern</option>
            <option value="Ondersteuning">Ondersteuning</option>
            <option value="Interne ondersteuning">Interne ondersteuning</option>
          </select>
        </div>
        <div>
          <!-- <input
            type="text"
            class="tekstveld blue"
            v-model="opdracht[0].werkplek"
            @input="isOpdrachtEdited = true"
            placeholder="werkplek"
          /> -->
          <!-- werkplek -->
          <select
            v-model="opdracht[0].werkplek"
            @change="isOpdrachtEdited = true"
            class="tekstveld correctSelect"
          >
            <option value="">Werkplek</option>
            <option value="Interne werkplek bij bedrijf"
              >Interne werkplek bij bedrijf</option
            >
            <option value="Eigen werkplek tekenaar"
              >Eigen werkplek tekenaar</option
            >
            <option value="Gecombineerd">Gecombineerd</option>
            <option value="Geen voorkeur">Geen voorkeur</option>
          </select>
          <span>{{ aanvraagdatum }}</span>
        </div>
      </div>

      <div class="discholder hoveron" style="margin-top:30px;margin-left:-3px;">
        <div
          @click="stuurNaarTekenaarsMetDiscipline(opdracht[0].disciplines)"
          class="discipline"
          :class="{
            pastel1: opdracht[0].disciplines == 'Bouwkunde',
            pastel2: opdracht[0].disciplines == 'Werktuigbouwkunde',
            pastel3: opdracht[0].disciplines == 'Installatietechniek',
            pastel4: opdracht[0].disciplines == 'Elektrotechniek',
            pastel5: opdracht[0].disciplines == 'Huisvesting',
            pastel6: opdracht[0].disciplines == 'Plattegronden',
            pastel7: opdracht[0].disciplines == 'Concepten - 3D Print',
            pastel8: opdracht[0].disciplines == 'Brandpreventie',
            pastel9: opdracht[0].disciplines == 'Nen2580',
          }"
        >
          {{ opdracht[0].disciplines }}
        </div>
      </div>

      <div class="vertical">
        <div style="padding-top:40px;">
          <span class="titeltekst ">Omschrijving</span>

          <div class="discholder" style="padding-top:10px;">
            <textarea
              class="aantekening blue"
              v-model="opdracht[0].omschrijving"
              @input="isOpdrachtEdited = true"
            ></textarea>
          </div>
        </div>
      </div>

      <UploadFileToOpdracht
        :opdrachtId="opdracht[0].id"
        :opdrachtFiles="opdracht[0].files"
      />
    </div>

    <!-- MORE INFO sectie -->
    <div class="section">
      <span class="titeltekst" style="display:block;">Intake</span>
      <div class="discholder" style="padding-top:10px;">
        <textarea
          class="intake"
          v-model="opdracht[0].intake"
          @input="isIntakeEdited = true"
        ></textarea>
        <button v-if="isIntakeEdited" @click="slaIntakeOpAlsLog()">
          Sla intake op als log
        </button>
        <button
          style="margin-left:10px;"
          v-if="isIntakeEdited"
          @click="slaIntakeOp()"
        >
          Sla intake op als intake
        </button>
      </div>
    </div>

    <!-- voortgang sectie -->
    <div class="section">
      <span class="titeltekst">Voortgang</span>
      <div class="vertical" style="padding-top:40px;">
        <div>
          <Voortgang :opdracht="opdracht[0]" />
        </div>
      </div>
    </div>

    <!-- koppel tekenaar sectie -->
    <div
      class="section"
      v-if="
        (opdracht[0].status == 'In behandeling' &&
          opdracht[0].tekenaarsid == '') ||
          opdracht[0].tekenaarsid == undefined
      "
    >
      <span class="titeltekst">Kies een tekenaar</span>
      <div class="vertical">
        <div style="padding-top:15px;">
          <!-- <select v-model="tekenaarVoorKoppel">
            <option v-for="tekenaar in allTekenaars" :key="tekenaar.id" :value="tekenaar.id">{{ tekenaar.naam }}</option> </select
          ><br /> -->
          <input
            class="nieuwitemfield"
            type="text"
            v-model="tekenaarGezocht"
            placeholder="Zoek tekenaar op naam"
          />
          <div v-if="tekenaarGezocht != ''">
            <div
              class="tekenaarlijstitem"
              v-for="(tekenaar, index) in filteredTekenaars"
              :key="index"
            >
              <span
                @click="tekenaarVoorKoppel = tekenaar.id"
                class="tekitem"
                :class="{
                  tekenaargeselecteerd: tekenaar.id == tekenaarVoorKoppel,
                }"
                >{{ tekenaar.naam }}</span
              >
              <div
                @click="
                  (tekenaarVoorKoppel = ''),
                    (tekenaargeselecteerd = ''),
                    (tekenaarGezocht = '')
                "
                class="removex"
                v-if="tekenaarVoorKoppel && tekenaar.id == tekenaarVoorKoppel"
              >
                X
              </div>
            </div>
          </div>
          <br />
          <!-- <span>Geselecteerde tekenaar = {{ tekenaarVoorKoppel }}</span> -->
          <button v-if="tekenaarVoorKoppel != ''" @click="sendeEmail()">
            Nodig tekenaar uit voor opdracht
          </button>
          <button v-if="tekenaarVoorKoppel != ''" @click="sendeEmailNOT()">
            Koppel tekenaar zonder acceptatie-email
          </button>
        </div>
      </div>
      <div v-if="interestedUsers">
        <br>
        <span>Geïnteresseerde tekenaars: {{interestedUsers.length}}</span>
        <br>
        <div  v-for="(tek, index) in interestedUsers" :key="index">
          
          <a :href="`mailto:${tek.userProfile.email}?subject=Update CDT.${opdracht[0].opdrachtnummerjaar}.${opdracht[0].opdrachtnummer}&body=Beste ${tek.userProfile.voornaam},%0D%0A%0D%0AJe hebt interesse getoont in CDT.${opdracht[0].opdrachtnummerjaar}.${opdracht[0].opdrachtnummer}.%0D%0AVandaag hebben wij de opdracht uitgestuurd naar jouw collega tekenaar. Je blijft in de lijst staan zodat wanneer er geen goede match is tussen de opodrachtgever en jouw collega jij alsnog in aanmerking komt op deze opdracht.%0D%0A%0D%0AGroet,%0D%0ACAD-Tekenaar.com%0D%0A%0D%0A---%0D%0ADit is een geautomatioseerde mail vanuit de CAD-Tekenaar.com Teampagina`" target="_blank">

          <span style="text-decoration:none;padding-top:7px;display:block;">{{tek.userProfile.voornaam}} {{tek.userProfile.achternaam}}</span>
          </a>
        </div>
        <br>
        <br>
        <a href="https://cad-tekenaar-admin.netlify.app/opdrachten" target="_blank">Bekijk admin 2.0 voor tek</a>
        
      </div>

    </div>


    <div
      class="section"
    >
      <div v-if="interestedUsers">
        <br>
        <span>Geïnteresseerde tekenaars: {{interestedUsers.length}}</span>
        <br>
        <div  v-for="(tek, index) in interestedUsers" :key="index">
          
          <a :href="`mailto:${tek.userProfile.email}?subject=Update CDT.${opdracht[0].opdrachtnummerjaar}.${opdracht[0].opdrachtnummer}&body=Beste ${tek.userProfile.voornaam},%0D%0A%0D%0AJe hebt interesse getoont in CDT.${opdracht[0].opdrachtnummerjaar}.${opdracht[0].opdrachtnummer}.%0D%0AVandaag hebben wij de opdracht uitgestuurd naar jouw collega tekenaar. Je blijft in de lijst staan zodat wanneer er geen goede match is tussen de opodrachtgever en jouw collega jij alsnog in aanmerking komt op deze opdracht.%0D%0A%0D%0AGroet,%0D%0ACAD-Tekenaar.com%0D%0A%0D%0A---%0D%0ADit is een geautomatioseerde mail vanuit de CAD-Tekenaar.com Teampagina`" target="_blank">

          <span style="text-decoration:none;padding-top:7px;display:block;">{{tek.userProfile.voornaam}} {{tek.userProfile.achternaam}}</span>
          </a>
        </div>
        <br>
        <br>
        <a href="https://cad-tekenaar-admin.netlify.app/opdrachten" target="_blank">Bekijk admin 2.0 voor tek</a>
        
      </div>

    </div>


    <!-- status sectie -->
    <div class="section">
      <div class="sectionheader">
        <span class="titeltekst">Status: {{ opdracht[0].status }}</span>
      </div>

      <div
        class="vertical"
        v-if="opdracht[0].geannuleerd != true && opdracht[0].onhold != true"
      >
        <div style="padding-top:15px;">
          <!-- <div>
            <span>{{ opdracht[0].status }} </span>
            <div
              v-if="opdracht[0].status == 'In behandeling'"
              style="width:10px;height:10px;background-color:green;border-radius:100px;display:inline-block"
            ></div>
          </div> -->
          <div class="buttonlist">
            <button
              v-if="opdracht[0].status == 'Nieuw'"
              @click="updateStatus('In behandeling')"
            >
              Zet status naar 'in behandeling'
            </button>
            <button
              v-if="opdracht[0].status == 'In behandeling'"
              @click="updateStatus('Nieuw')"
            >
              Zet status terug naar 'nieuw'
            </button>
            <button
              style="margin-bottom:20px;"
              class="orange"
              v-if="opdracht[0].status != 'Beëindigd'"
              @click="zetOpdrachtOnHold"
            >
              Zet opdracht On Hold
            </button>
            <button
              style="margin-bottom:20px;"
              v-if="opdracht[0].geannuleerd != true"
              @click="annuleerOpdracht"
              class="red"
            >
              Annuleer deze opdracht
            </button>
          </div>
        </div>
      </div>
      <div class="vertical" v-if="opdracht[0].geannuleerd == true">
        <div style="padding-top:15px;">
          <div>
            <span>Deze opdracht is geannuleerd</span>
            <button
              v-if="opdracht[0].geannuleerd == true"
              @click="zetOpdrachtTerug"
              class="red"
            >
              Zet deze opdracht terug
            </button>
          </div>
        </div>
      </div>
      <div class="vertical" v-if="opdracht[0].onhold == true">
        <div style="padding-top:15px;">
          <div>
            <span>Deze opdracht staat On Hold</span>
            <button
              v-if="opdracht[0].onhold == true"
              @click="maakOpdrachtWeerActief"
              class="orange"
            >
              Maak deze opdracht weer actief
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- gekoppelde tekenaar zien sectie -->
    <div
      class="section"
      v-if="
        opdracht[0].tekenaarsid != '' && opdracht[0].tekenaarsid != undefined
      "
    >
      <span class="titeltekst">Gekoppelde tekenaar</span> <br />
      <div v-if="opdracht[0].status == 'Toegewezen'" class="letop">
        Deze tekenaar is toegewezen zonder acceptatie-mail.
      </div>
      <div class="vertical">
        <div style="padding-top:15px;">
          <span
            class="tekenaar"
            @click="$emit('select-tekenaar', gekoppeldeTekenaar[0].id)"
            >{{ gekoppeldeTekenaar[0].naam }}</span
          ><br />
          <button
            v-if="opdracht[0].status == 'Toegewezen'"
            @click="sendeEmailBijToegewezen()"
          >
            Verstuur acceptatie-mail
          </button>
          <button @click="ontkoppelTek()">
            Ontkoppel deze tekenaar van opdracht
          </button>
        </div>
      </div>
    </div>

    <!-- market opdracht naar alle tekenaars sectie -->
    <div
      class="section"
      v-if="
        opdracht[0].status == 'In behandeling' && opdracht[0].gemarket != 'Ja'
      "
    >
      <span class="titeltekst"
        >Stuur uit naar {{ tekenaarsInOpdrDiscipline.length }}
        {{ opdracht[0].disciplines.toLowerCase() }} tekenaars</span
      >
      <div class="vertical">
        <div style="padding-top:15px;">
          <button @click="stuurOpdrachtUit()">
            Verstuur opdracht naar tekenaars
          </button>
          <button @click="stuurOpdrachtUitTEST()">
            Stuur testmail naar info@cad-tekenaar.com
          </button>
        </div>
      </div>
    </div>
    <!-- IF GEMARKET -->
    <div
      class="section"
      v-if="
        opdracht[0].status == 'In behandeling' && opdracht[0].gemarket == 'Ja'
      "
    >
      <span class="titeltekst"
        >Deze opdracht is verstuurd naar bijpassende tekenaars</span
      >
    </div>

    <!-- log sectie -->
    <div v-if="opdracht[0].log != undefined" class="section">
      <span class="titeltekst">Log</span>
      <div class="vertical">
        <div style="padding-top:15px;">
          <div
            v-for="(logentry, index) in orderBy(opdracht[0].log, 'id', -1)"
            :key="index"
            class="logentry"
          >
            <span v-if="logentry.manual" class="manuallogentry"> </span>
            <span>{{ logentry.log }}</span
            ><br />
            <span style="opacity:0.5;font-size:13px;">
              {{ timestampReadable(logentry.timestamp) }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="buttonlist" style="padding-right:40px;">
      <button
        @click="dupliceerOpdracht()"
        style="margin-left: 40px;margin-bottom:20px;box-sizing:border-box;"
      >
        Dupliceer deze opdracht
      </button>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";

import db from "@/firebase/firebaseInit";

import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import store from "../../store";
import router from "../../router";

import Vue2Filters from "vue2-filters";

import Voortgang from "../ui-elements/Voortgang";
import UploadFileToOpdracht from "../ui-elements/UploadFileToOpdracht";
// import DropdownSelect2 from '../pages/Tekenaars/DropdownSelect2';

export default {
  name: "OpdrModal",
  components: {
    Voortgang,
    UploadFileToOpdracht,
    // DropdownSelect2
  },

  watch: {
    opdracht: {
      immediate: true,
      handler(newValue) {
        console.log(newValue);
        let newArrayOfInterestedUsers = []
        console.log(this.opdracht[0]?.interestedUsers);
        if (!this.opdracht[0].interestedUsers) return this.interestedUsers = []
        this.opdracht[0].interestedUsers.forEach(user => {
        
        let userAccounts = [...this.userAccountsOfTekenaars]
        const newList = userAccounts.filter(e => e.id === user.userId)
        
        console.log(user.userId);
        newArrayOfInterestedUsers.push(newList[0])
      })
      this.interestedUsers = newArrayOfInterestedUsers
        }
    }
  },
  data() {
    return {
      interestedUsers: '',
      cfMailLoading: false,
      tekenaarVoorKoppel: "",
      opdrachtLiveEditablee: {},
      isOpdrachtEdited: false,
      isIntakeEdited: false,

      tekenaarGezocht: "",
    };
  },
  props: {
    opdrachtid: String,
  },
  mixins: [Vue2Filters.mixin],
  computed: {
    ...mapGetters(["allOpdrachten", "allTekenaars"]),

    userAccountsOfTekenaars() {
      return this.$store.state.userAccounts
    },

    opdrachtgeverAcceptedCFVoorwaarden() {
      if (this.opdracht[0].acceptedCFVoorwaarden) return true;
      return false;
    },

    cfVoorwaardenMailGestuurd() {
      if (this.opdracht[0].cfVoorwaardenMailVerstuurd) return true;
      return false;
    },

    isUploadLoading() {
      return store.state.uploadFile.loading;
    },

    opdarchtNummerJaarDynamisch() {
      return new Date().getFullYear();
    },
    opdarchtNummerMaandDynamisch() {
      const currentMonth = new Date().getMonth() + 1; //Hij begint met tellen bij 0! => dus + 1
      if (currentMonth > 9) return currentMonth;
      return "0" + currentMonth;
    },

    filteredTekenaars() {
      let Nieuwelijst = [];
      const ting = this.allTekenaars.filter((tekenaar) => {
        return tekenaar.naam
          .toLowerCase()
          .includes(this.tekenaarGezocht.toLowerCase());
      });
      ting.forEach((element) => {
        let newElement = {
          ...element,
        };
        Nieuwelijst.push(newElement);
      });
      return Nieuwelijst;
    },

    hoogsteOpdrachtnummer() {
      const maxId = this.allOpdrachten.reduce(
        (max, character) =>
          character.opdrachtnummer > max ? character.opdrachtnummer : max,
        this.allOpdrachten[0].opdrachtnummer
      );
      return maxId;
    },

    opdracht() {
      return this.allOpdrachten.filter((opdracht) => {
        if (opdracht.id == this.opdrachtid) {
          return opdracht;
        }
      });
    },
    opdrachtLiveEditable() {
      return true;
    },
    opdrachtLive: {
      get() {
        return this.opdracht[0];
      },
      set(val) {
        this.opdrachtLiveEditablee = val;
      },
    },
    aanvraagdatum() {
      if (this.opdracht[0].aanvraagdatum.substr(0, 1) == '"') {
        return this.opdracht[0].aanvraagdatum.substr(1, 10);
      } else {
        return this.opdracht[0].aanvraagdatum.substr(0, 10);
      }
    },
    log() {
      return this.opdracht[0].log;
    },
    gekoppeldeTekenaar() {
      return this.allTekenaars.filter((tekenaar) => {
        if (tekenaar.id == this.opdracht[0].tekenaarsid) {
          return tekenaar;
        }
      });
    },
    tekenaarsInOpdrDiscipline() {
      return this.allTekenaars.filter((tekenaar) =>
        tekenaar.disciplines.includes(this.opdracht[0].disciplines)
      );
    },
    tekFilters() {
      return store.state.tekFilters;
    },
    showTekFilters() {
      return store.state.showTekFilters;
    },
  },
  methods: {
    ...mapActions(["addLogEntry", "sendEmail", "duplicateOpdrToDB"]),

    async sendCFmail() {
      this.cfMailLoading = true;
      if (
        confirm(
          `Wil je een C.F. voorwaarden email versturen naar ${this.opdracht[0].email}`
        )
      ) {
        db.collection("CF_AkkoordMail")
          .add({
            opdrachtId: this.opdracht[0].id,
            bedrijfsNaam: this.opdracht[0].bedrijfsnaam,
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
          })
          .then(() => {
            db.doc(`opdrachten/${this.opdracht[0].id}`).update({
              cfVoorwaardenMailVerstuurd: true,
            });
          })
          .then(() => {
            alert("Mail Verstuurd");
          });
        // add doc to collection 'CF_AkkoordMail'
        // send email here by creating a doc in db
      }
    },

    addDocToDB() {},

    stuurNaarTekenaarsMetDiscipline(disciplline) {
      this.tekFilters.disciplines = disciplline;
      store.commit("updateTekFilters", this.tekFilters);
      store.commit("toggleShowTekFilters", this.showTekFilters);
      router.push("tekenaars");
    },

    dupliceerOpdracht() {
      const date = new Date().getDate().toString();
      const year = new Date().getFullYear().toString();
      const month = new Date().getMonth().toString();
      const timestamp = year + "-" + month + "-" + date;
      const payload = {
        bedrijfsnaam: this.opdracht[0].bedrijfsnaam || "",
        opdrachtnummerjaar: this.opdarchtNummerJaarDynamisch,
        opdrachtnummermaand: this.opdarchtNummerMaandDynamisch,
        email: this.opdracht[0].email || "",
        voornaam: this.opdracht[0].voornaam || "",
        achternaam: this.opdracht[0].achternaam || "",
        geannuleerd: false,
        onhold: false,
        telefoonnummer: this.opdracht[0].telefoonnummer || "",
        omschrijving: this.opdracht[0].omschrijving || "",
        disciplines: this.opdracht[0].disciplines || "",
        tekenprogramma: this.opdracht[0].tekenprogramma || "",
        intake: this.opdracht[0].intake || "",
        opdrachtnummer: this.hoogsteOpdrachtnummer + 1,
        werplek: this.opdracht[0].werkplek || "",
        aanvraagdatum: timestamp,
        typeopdracht: this.opdracht[0].typeopdracht || "",
      };
      this.duplicateOpdrToDB(payload);
      this.$emit("close-Modal");
      this.$emit("");
    },
    saveChanges() {
      store.dispatch("saveOpdrChanges", this.opdracht[0]);
      this.isOpdrachtEdited = false;
    },

    slaIntakeOpAlsLog() {
      this.isIntakeEdited = false;
      this.saveChanges();
      this.setLogManual(this.opdracht[0].intake);
    },
    slaIntakeOp() {
      this.isIntakeEdited = false;
      this.saveChanges();
    },

    annuleerOpdracht() {
      if (confirm("LET OP! Deze opdracht annuleren?")) {
        console.log("annuleren van opdr begint");
        store.dispatch("annuleerOpdracht", this.opdracht[0].id);
      }
    },

    zetOpdrachtOnHold() {
      if (confirm("LET OP! Deze opdracht on hold zetten?")) {
        console.log("on hold zetten van opdr begint");
        store.dispatch("zetOpdrachtOnHold", this.opdracht[0].id);
      }
    },

    zetOpdrachtTerug() {
      if (confirm("LET OP! Wil je deze opdracht weer actief maken?")) {
        console.log("opdracht terugzetten begint");
        store.dispatch("zetOpdrachtTerug", this.opdracht[0].id);
      }
    },

    maakOpdrachtWeerActief() {
      if (confirm("Let op! Wil je deze opdracht weer actief maken?")) {
        console.log("opdracht onhold naar 'false' zetten begint");
        store.dispatch("maakOpdrachtWeerActief", this.opdracht[0].id);
      }
    },

    tekenaarOpId() {
      return this.allTekenaars.filter((tekenaar) => {
        if (this.tekenaarVoorKoppel == tekenaar.id) {
          return tekenaar;
        }
      });
    },

    sendeEmailBijToegewezen() {
      const emailTekenaar = this.gekoppeldeTekenaar[0].email;
      const naamTekenaar = this.gekoppeldeTekenaar[0].naam;
      const opdrachtgeverContactpersoon =
        this.opdracht[0].voornaam + " " + this.opdracht[0].achternaam;
      const opdrachtgeverBedrijfsnaam = this.opdracht[0].bedrijfsnaam;
      const opdrachtnummer = this.opdracht[0].opdrachtnummer;
      const opdrachtgeverEmail = this.opdracht[0].email;
      const opdrachtgeverTelefoonnummer = this.opdracht[0].telefoonnummer;

      const tekenaarsid = this.gekoppeldeTekenaar[0].id;
      const payload = {
        emailTekenaar: emailTekenaar,
        naamTekenaar: naamTekenaar,
        opdrachtgeverContactpersoon: opdrachtgeverContactpersoon,
        opdrachtgeverBedrijfsnaam: opdrachtgeverBedrijfsnaam,
        opdrachtnummer: opdrachtnummer,
        opdrachtgeverEmail: opdrachtgeverEmail,
        opdrachtgeverTelefoonnummer: opdrachtgeverTelefoonnummer,
        status: "Uitgezet",
        opdrachtid: this.opdrachtid,
        tekenaarsid: tekenaarsid,
      };
      if (confirm("Deze opdracht uitzetten naar: " + emailTekenaar + "?")) {
        store.dispatch("sendEmail", payload);
        store.dispatch("updateOpdrStatus", payload);
        store.dispatch("koppelTekAanOpdr", payload);
        this.setLog("Akkoordmail verstuurd naar tekenaar " + emailTekenaar);
      }
    },

    sendeEmail() {
      const emailTekenaar = this.tekenaarOpId()[0].email;
      const naamTekenaar = this.tekenaarOpId()[0].naam;
      const opdrachtgeverContactpersoon =
        this.opdracht[0].voornaam + " " + this.opdracht[0].achternaam;
      const opdrachtgeverBedrijfsnaam = this.opdracht[0].bedrijfsnaam;
      const opdrachtnummer = this.opdracht[0].opdrachtnummer;
      const opdrachtgeverEmail = this.opdracht[0].email;
      const opdrachtgeverTelefoonnummer = this.opdracht[0].telefoonnummer;

      const tekenaarsid = this.tekenaarOpId()[0].id;
      const payload = {
        emailTekenaar: emailTekenaar,
        naamTekenaar: naamTekenaar,
        opdrachtgeverContactpersoon: opdrachtgeverContactpersoon,
        opdrachtgeverBedrijfsnaam: opdrachtgeverBedrijfsnaam,
        opdrachtnummer: opdrachtnummer,
        opdrachtgeverEmail: opdrachtgeverEmail,
        opdrachtgeverTelefoonnummer: opdrachtgeverTelefoonnummer,
        status: "Uitgezet",
        opdrachtid: this.opdrachtid,
        tekenaarsid: tekenaarsid,
      };
      if (confirm("Deze opdracht uitzetten naar: " + emailTekenaar + "?")) {
        store.dispatch("sendEmail", payload);
        store.dispatch("updateOpdrStatus", payload);
        store.dispatch("koppelTekAanOpdr", payload);
        this.setLog("Akkoordmail verstuurd naar tekenaar " + emailTekenaar);
      }
    },
    sendeEmailNOT() {
      const emailTekenaar = this.tekenaarOpId()[0].email;
      const naamTekenaar = this.tekenaarOpId()[0].naam;
      const opdrachtgeverContactpersoon =
        this.opdracht[0].voornaam + " " + this.opdracht[0].achternaam;
      const opdrachtgeverBedrijfsnaam = this.opdracht[0].bedrijfsnaam;
      const opdrachtnummer = this.opdracht[0].opdrachtnummer;
      const opdrachtgeverEmail = this.opdracht[0].email;
      const opdrachtgeverTelefoonnummer = this.opdracht[0].telefoonnummer;

      const tekenaarsid = this.tekenaarOpId()[0].id;
      const payload = {
        emailTekenaar: emailTekenaar,
        naamTekenaar: naamTekenaar,
        opdrachtgeverContactpersoon: opdrachtgeverContactpersoon,
        opdrachtgeverBedrijfsnaam: opdrachtgeverBedrijfsnaam,
        opdrachtnummer: opdrachtnummer,
        opdrachtgeverEmail: opdrachtgeverEmail,
        opdrachtgeverTelefoonnummer: opdrachtgeverTelefoonnummer,
        status: "Toegewezen",
        opdrachtid: this.opdrachtid,
        tekenaarsid: tekenaarsid,
      };
      if (
        confirm(
          "Deze opdracht koppelen aan: " +
            naamTekenaar +
            "? Zonder email-bevestiging van zijn kant uit? De tekenaar wordt dus niet op de hoogte gesteld van deze actie."
        )
      ) {
        store.dispatch("updateOpdrStatus", payload);
        store.dispatch("koppelTekAanOpdr", payload);
        this.setLog(
          "Tekenaar gekoppeld aan opdracht (zonder acceptatie email): " +
            naamTekenaar
        );
      }
    },
    stuurOpdrachtUit() {
      if (
        confirm(
          "Deze opdracht sturen naar " +
            this.tekenaarsInOpdrDiscipline.length +
            " " +
            this.opdracht[0].disciplines.toLowerCase() +
            " tekenaars?"
        )
      ) {
        const emaillistholder = [];
        const thing = this.allTekenaars.filter((tekenaar) => {
          return tekenaar.disciplines.includes(this.opdracht[0].disciplines);
        });
        thing.forEach((element) => {
          emaillistholder.push(element.email);
        });
        const payload = {
          emailList: emaillistholder,
          opdrachtnummer: this.opdracht[0].opdrachtnummer,
          discipline: this.opdracht[0].disciplines,
          tekenprogramma: this.opdracht[0].tekenprogramma,
          intakeveld: this.opdracht[0].intake,
        };
        store.dispatch("sendMarketingEmail", payload);
        (this.opdracht[0].gemarket = "Ja"), this.saveChanges();
        this.setLog(
          "Opdracht uitgestuurd naar " +
            this.tekenaarsInOpdrDiscipline.length +
            " " +
            this.opdracht[0].disciplines.toLowerCase() +
            " tekenaars"
        );
      }
    },
    stuurOpdrachtUitTEST() {
      // const emaillistholder = [];
      // const thing = this.allTekenaars.filter(tekenaar => {
      //   return tekenaar.disciplines.includes(this.opdracht[0].disciplines);
      // });
      // thing.forEach(element => {
      //   emaillistholder.push(element.email);
      // });
      const payload = {
        // emailList: emaillistholder,
        opdrachtnummer: this.opdracht[0].opdrachtnummer,
        discipline: this.opdracht[0].disciplines,
        tekenprogramma: this.opdracht[0].tekenprogramma,
        intakeveld: this.opdracht[0].intake,
      };
      store.dispatch("sendMarketingEmailTEST", payload);
    },
    ontkoppelTek() {
      const payload = {
        //tekenaarsid: this.opdracht[0].id,
        opdrachtid: this.opdracht[0].id,
        status: "In behandeling",
      };
      if (confirm("LET OP! Deze tekenaar v.d. opdracht afhalen?")) {
        store.dispatch("ontkoppelTekVanOpdr", payload);
        store.dispatch("updateOpdrStatus", payload);
        this.setLog("Opdracht ontkoppeld van tekenaar");
      }
    },
    timestampReadable(e) {
      var d = new Date(e);
      return d.toGMTString();
    },
    updateStatus(payload) {
      const payloadGen = {
        status: payload,
        opdrachtid: this.opdracht[0].id,
      };
      store.dispatch("updateOpdrStatus", payloadGen);
      this.setLog("Opdrachtstatus veranderd naar " + payload);
    },
    setLog(payload) {
      var maxid = 0;
      if (Array.isArray(this.log)) {
        this.log.map(function(obj) {
          if (obj.id > maxid) maxid = obj.id;
        });
      }
      const newlog = {
        timestamp: Date.now(),
        id: maxid + 1,
        log: payload,
      };
      const payloadLog = {
        id: this.opdracht[0].id,
        log: newlog,
      };
      store.dispatch("updateOpdrLog", payloadLog);
    },
    setLogManual(payload) {
      var maxid = 0;
      if (Array.isArray(this.log)) {
        this.log.map(function(obj) {
          if (obj.id > maxid) maxid = obj.id;
        });
      } else {
        console.log("fuck");
      }
      const newlog = {
        timestamp: Date.now(),
        id: maxid + 1,
        log: payload,
        manual: true,
      };
      const payloadLog = {
        id: this.opdracht[0].id,
        log: newlog,
      };
      store.dispatch("updateOpdrLog", payloadLog);
    },

    closemodal() {
      if (this.isOpdrachtEdited == false) {
        this.$emit("close-Modal");
      } else {
        alert("Sla eerst de gemaakte wijzigingen op!");
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.notification
  background-color: #fff
  padding: 20px 10px
  border-radius: 10px
  border: 1px solid black
  font-size: 15px
  .top
    display: flex
    align-items: center
    .itemmm
      min-width: 16%
      max-width: 16%
      margin-right: 10px
      display: flex
      align-items: center
      justify-content: center
    i
      font-size: 30px
    span
      display: block
      max-width: 34ch

  button
    background-color: #FF1B1B
    color: white
    border-radius: 4px
    font-size: 13px
    border: none
    padding-top: 7px
    margin-left: calc( 16% + 10px )
    &:hover
      background-color: #FF1B1B
      opacity: .7

  &.accepted
    background-color: #D8FFE4
    color: #00A52D
    border-color: #00A52D
  &.rejected
    background-color: #FFE3E3
    color: #FF1B1B
    border-color: #FF1B1B
</style>

<style scoped>
.loadingState {
  filter: blur(5px);
}
.manuallogentry {
  width: 10px;
  margin-right: 6px;
  height: 10px;
  border-radius: 100%;
  position: relative;
  display: inline-block;
  background-color: green;
}

@media screen and (max-width: 663px) {
  .tekmodal {
    z-index: 2;
    position: fixed;
    overflow-y: scroll;
    left: auto;
    top: 0%;
    right: 0%;
    bottom: 0%;
    width: 100%;
    background-color: #fff;
    box-shadow: -20px 0 50px 0 rgba(0, 0, 0, 0.11);
    padding-bottom: 100px;
  }
}

.hoveron {
  cursor: pointer;
}

.letop {
  border-radius: 6px;
  background-color: #f7d4ab;
  padding: 10px;
  font-size: 14px;
  color: #ff6c00;
  text-align: center;
  margin-top: 20px;
  font-weight: 600;
  width: 100%;
}

.tekenaargeselecteerd {
  background-color: #3076ea;
  color: #fff;
}
.correctSelect {
  cursor: pointer;
  font-weight: 500;
  border: none;
  -webkit-appearance: none;
  background: none;
  color: #000;
  font-size: 14px;
  /* width: inherit; */
  font-family: poppins;
  text-align: center;
}
.nieuwitemfield {
  padding: 10px;
  border-radius: 6px;
  -webkit-appearance: none;
  width: 70%;
  margin-bottom: 10px;
}

.tekenaarlijstitem {
  display: block;
  padding: 5px 0;
  cursor: pointer;
}

.tekitem {
  padding: 10px;
  border-radius: 6px;
}

.buttonlist {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: left;
}

.tekenaar {
  padding: 10px 0px;
  border-bottom: 1px solid #e4ecfa;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
.tekenaar:hover {
  background-color: #e4ecfa;
}

button {
  margin-top: 20px;
  color: #0475f2;
  border: 1px solid #0475f2;
  border-radius: 5px;
  padding: 8px 11px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  background-color: white;
}
button:hover {
  color: #fff;
  background-color: #0475f2;
}
button:active {
  color: #fff;
  background-color: #1b4d8d;
}
.removex {
  padding: 7px;
  text-align: center;
  padding-right: 8px;
  margin-left: 10px;
  display: inline-block;
  border-radius: 100px;
  background-color: #b8c3d5;
  width: 40px;
  height: 40px;
}
.removex:hover {
  opacity: 0.8;
}
button.red {
  border-color: #f1646c;
  color: #f1646c;
  margin-top: 0px;
}
button.red:hover {
  background-color: #f1646c;
  color: #fff;
}

button.orange {
  border-color: #ff9326;
  color: #ff9326;
}
button.orange:hover {
  background-color: #ff9326;
  color: #fff;
}

.annuleersection {
  padding: 20px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e4ecfa;
  cursor: pointer;
}
.annuleersection:hover {
  background-color: #e3170a87;
}

.blue {
  background-color: #e4ecfa;
  position: sticky !important;
  top: 70px;
  z-index: 1;
}

.blue.tekstveld {
  background: none;
}

.header {
  color: #fff;
  font-weight: 600;
  padding-right: 30px;
  font-size: 18px;
}
.headerleft {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.ico {
  background-color: #ff9326;
  width: 28px;
  height: 28px;
  border-radius: 5px;
  padding: 4px;
  margin-right: 10px;
}

.header-buttons {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.sectionheader {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.annuleerbutton {
  background-color: #ff9326;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  cursor: pointer;
  margin-right: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 1px;
}

.close-btn {
  width: 24px;
  height: 24px;
  display: flex;
  cursor: pointer;
  transition: 0.3s;
}
.close-btn:hover {
  transform: scale(1.2);
}

.savesection {
  background-color: #ff9326;
  color: #fff;
  display: flex;
  width: 100%;
  max-width: 520px;
  padding: 24px;
  justify-content: center;
  cursor: pointer;
  font-weight: 600;
  position: fixed;
  bottom: 0;
  z-index: 1;
}

.tekmodal {
  z-index: 4;
  position: fixed;
  overflow-y: scroll;
  left: auto;
  transition: 0.3s;
  top: 0%;
  right: 0%;
  bottom: 0%;
  min-width: 520px;
  max-width: 520px;
  background-color: #fff;
  box-shadow: -20px 0 50px 0 rgba(0, 0, 0, 0.11);
}
.modalheader {
  display: flex;
  height: 70px;
  padding: 0 25px;
  justify-content: space-between;
  align-items: center;
  background-color: #1b4d8d;
  color: white;
  font-size: 16px;
  font-weight: 600;
  position: sticky;
  top: 0px;
  z-index: 5;
}

.section {
  padding: 40px;
  position: relative;
  border-bottom: 1px solid #e4ecfa;
}
.titeltekst {
  font-weight: 600;
  font-size: 20px !important;
}

.threecolumnsholder {
  display: flex;
  justify-content: space-between;
  align-items: top;
  width: 100%;
}

.threecolumnsholder div {
  width: 100%;
  padding-top: 15px;
  font-size: 15px;
  display: flex;
  flex-direction: column;
}

.vertical {
  display: flex;
  flex-direction: column;
}

.discipline {
  background-color: #e4ecfa;
  border-radius: 100px;
  padding: 5px 10px;
  display: inline;
  /* display: flex;
        align-items: center;
        justify-content: center; */
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  margin-right: 7px;
  /* border: 2px solid white; */
}

.tekstveld {
  font-size: 15px;
  font-family: "Poppins", sans-serif;
  border: 0px;
}
.tekstveld:hover {
  background-color: #ffdab5;
  cursor: pointer;
}
.tekstveld:focus {
  background-color: #ffdab5;
}

.aantekening {
  font-family: "Poppins", sans-serif;
  height: 140px;
  font-size: 16px;
  border-width: 0px;
  width: 100%;
}
.aantekening:hover {
  background-color: #ffdab5;
  cursor: pointer;
}
.aantekening:focus {
  background-color: #ffdab5;
}

.intake {
  font-family: "Poppins", sans-serif;
  height: 130px;
  font-size: 16px;
  border-width: 0px;
  width: 100%;
  font-style: italic;
  color: #888;
}
.intake:hover {
  background-color: #ffdab5;
  cursor: pointer;
}
.intake:focus {
  background-color: #ffdab5;
}
</style>
